import { currentLanguage } from './translator';
import { defaultCurrency } from '@/config/app';

/**
 * The options can return currencies in lowercase or be empty, this is a workaround to normalize it
 * example:
 *   'chf' -> 'CHF'
 *   'usd' -> 'USD'
 *   '' -> 'CHF' (defaults to CHF)
 */
export function normalizeCurrency(currency: string): string {
  return (currency || defaultCurrency).toUpperCase();
}

/**
 * Formats the given currency value into a string
 * example:
 *   1000 -> 10 CHF
 */
export function formatCurrency(value: number, currency?: string): string {
  const floatingValue = (value ?? 0) / 100;
  return floatingValue.toLocaleString(currentLanguage.replace('_', '-'), {
    style: 'currency',
    currency: normalizeCurrency(currency ?? defaultCurrency),
  });
}

/**
 * Get currency sign
 * example:
 *   'EUR' -> '€'
 */
export function getCurrencySign(currency: string): string {
  if (currency === 'CHF') return 'CHF';
  if (currency === 'USD') return '$';
  if (currency === 'EUR') return '€';
  return '$';
}
